module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"itemsTotal":"{n} item in total | {n} items in total","editMyCart":"Edit my shopping cart","orderSummary":"Order Summary","quantity":"Quantity","total":"Total"},"de":{"itemsTotal":"{n} Artikel im Warenkorb","editMyCart":"Warenkorb bearbeiten","orderSummary":"Bestellübersicht","quantity":"Menge","total":"Gesamtpreis"}}')
  delete Component.options._Ctor
}
